var map = {
	"./audio-placeholder": 543,
	"./audio-placeholder.png": 543,
	"./avatar-missing": 362,
	"./avatar-missing.png": 362,
	"./avatar-missing.svg": 1006,
	"./header-missing": 371,
	"./header-missing.png": 371,
	"./soapbox-logo": 372,
	"./soapbox-logo-white": 373,
	"./soapbox-logo-white.svg": 373,
	"./soapbox-logo.svg": 372,
	"./video-placeholder": 544,
	"./video-placeholder.png": 544,
	"./void": 545,
	"./void.png": 545,
	"./web-push/web-push-icon_expand": 567,
	"./web-push/web-push-icon_expand.png": 567,
	"./web-push/web-push-icon_favourite": 568,
	"./web-push/web-push-icon_favourite.png": 568,
	"./web-push/web-push-icon_reblog": 569,
	"./web-push/web-push-icon_reblog.png": 569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1005;